import { createContext, useContext } from "react"

import { ScrollableModelImpl } from "@/components/Scrollable/ScrollableModel.ts"

import type { ScrollableModel } from "@/components/Scrollable/ScrollableModel.ts"


export const ScrollableContext = createContext<ScrollableModel>(new ScrollableModelImpl())

export function useScrollableModel() {
  return useContext(ScrollableContext)
}